__turbopack_context__.v({
  "root": "styles-module-scss-module__ftQWEG__root",
  "root__isCollapsed": "styles-module-scss-module__ftQWEG__root__isCollapsed",
});
